<template>
    <div>
        <ds-list-item
            v-for="item in listItems"
            :key="item.id"
            #title
            clickable
            target="_blank"
            @click="handleClick(item)"
        >
            <ds-avatar :name="item.id.toString()" /> {{ item.label }}
        </ds-list-item>

        <ds-modal
            :is-open="isOpen"
            show-close
            size="med"
            title="Make unsubscribe link easily accessible"
            @close="closeUnsubscribeModal"
        >
            <div>
                <p>
                    Make it easy for people to unsubscribe! Don’t attempt to hide the unsubscribe link by adding extra spacing.
                    If your recipients cannot find the opt-out link they will resort to reporting the email as spam.
                    This can contribute to complaint rates that can damage your email reputation.
                </p>
                <p>
                    For Keap Broadcasts and marketing emails in Automations, the Unsubscribe link is automatically appended at the bottom of the design as part of CAN-SPAM laws.
                </p>
            </div>
        </ds-modal>
    </div>
</template>


<script>

import amplitude from '../util/analytics/amplitude';

const CLASSIC_LINKS = [
    {
        id: 1,
        link: 'https://help.infusionsoft.com/help/custom-double-opt-in-link',
        label: 'Set Double Opt In',
    },
    {
        id: 2,
        link: '',
        label: 'Make Unsubscribe Link Easily Accessible',
    },
    {
        id: 3,
        link: 'https://help.infusionsoft.com/help/how-to-avoid-content-filters',
        label: 'Check your subject Line and Content',
    },
    {
        id: 4,
        link: 'https://help.infusionsoft.com/help/explicit-permission',
        label: 'Opt-In: Get Explicit Permission and Set Expectations',
    },
    {
        id: 5,
        link: 'https://help.infusionsoft.com/help/list-hygiene',
        label: 'Review List Hygiene',
    },
];

const KEAP_LINKS = [
    {
        id: 1,
        link: 'https://help.keap.com/help/email-confirmation-sequence',
        label: 'Set Up Email Confirmation Sequence',
    },
    {
        id: 2,
        link: '',
        label: 'Make Unsubscribe Link Easily Accessible',
    },
    {
        id: 3,
        link: 'https://help.keap.com/help/how-to-avoid-content-filters',
        label: 'Check your subject Line and Content',
    },
    {
        id: 4,
        link: 'https://help.keap.com/help/explicit-permission-emailguide',
        label: 'Opt-In: Get Explicit Permission and Set Expectations',
    },
    {
        id: 5,
        link: 'https://help.keap.com/help/list-hygiene',
        label: 'Review List Hygiene',
    },
];

export default {
    props: {
        appEdition: String,
    },
    data() {
        return {
            isOpen: false,
        };
    },

    computed: {
        icon() {
            return 'circle';
        },
        time() {
            return '10 mins';
        },

        listItems() {
            if (this.appEdition === 'Keap Max Classic Edition') {
                return CLASSIC_LINKS;
            }

            return KEAP_LINKS;
        },
    },
    methods: {
        handleClick(object) {
            if (object.id === 2) {
                this.navigateToListItemModal();
            } else {
                window.open(object.link, '_blank');
            }
            this.emitAmplitudeEvent(object.label);
        },
        openUnsubscribeModal() {
            this.isOpen = true;
        },
        closeUnsubscribeModal() {
            this.isOpen = false;
        },
        navigateToListItemModal() {
            this.emitAmplitudeEvent('CTA 2: make unsubscribe link easily accessible');
            this.openUnsubscribeModal();
        },
        emitAmplitudeEvent(event) {
            amplitude.infusionsoft.track('Email Analytics - CTA / Help', {
                'Event Source': 'Email Analytics Complaints Page',
                Destination: event,
            });
        },
    },
};

</script>

<style lang="scss" scoped>

    .title-wrapping {
        display: flex;
        overflow-wrap: break-word;
    }

    .list-item-time {
        font-size: $font-size-xs;
        line-height: $font-size-md;
        color: $color-gray-800;
        padding-bottom: $spacing-050;
        display: flex;
    }

    .one-line {
        display: flex;
    }

    .list-item-description {
        font-size: $font-size-md;
        padding-right: $spacing-200;
        font-color: $color-gray-900;
        display: flex;
        overflow-wrap: break-word;
    }

    .task-time {
        display: flex;
        justify-content: center;
        align-content: center;
        flex-direction: column;
        padding-left: $spacing-050;
    }

    .clock-with-time {
        flex: auto;
    }

</style>
